export default "__VITE_ASSET__BvoODOJP__"